// Copyright 2016 The MathWorks, Inc.

define([
    "dojo/_base/declare",
    "./TreeWorkaround"
], function (declare, TreeWorkaround) {
    return declare([TreeWorkaround], {
    });
});